import Navbar from "../blocks/navbar";
import BreadcrumbPage from "../blocks/breadcrumb"
import Footer from "../blocks/footer";
import * as React from "react";
import {useTranslation} from "react-i18next";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {useEffect, useState} from "react";
import ReactPaginate from "react-paginate";
import {format} from "date-fns";
import {connect} from "react-redux";
import {getAllOpenDocuments} from "../store/openDocuments";

function OpenDocuments(props){
    const {t, i18n} = useTranslation();
    const [documents, setDocuments] = useState([])

    useEffect(()=>{
        props.getAllOpenDocuments()
    }, [])


    useEffect(()=>{
        setDocuments(props.open_documents)
    }, [props])

    // Pagination

    const [itemsPerPage, setItemsPerPage] = useState(12)

    const [itemOffset, setItemOffset] = useState(0);

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = documents.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(documents.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % documents.length;
        setItemOffset(newOffset);
    };

    return <div>
        <Navbar/>
        <BreadcrumbPage props={'open_documents'}/>
        <div className={'page documents'}>
            <div className="container">
                <h2>{t('open_documents')}</h2>
                <div>
                    <table className="table table-striped table-borderless">
                        <thead>
                        <tr>
                            <th scope="col">№</th>
                            <th scope="col">{t('type_document')}</th>
                            <th scope="col">{t('date')}</th>
                            <th scope="col">{t('document_name')}</th>
                            <th scope="col">{t('see')}</th>
                        </tr>
                        </thead>
                        <tbody role={'rowgroup'}>
                        {currentItems.length ? currentItems.map((item, index)=><tr key={index} role={'row'}>
                            <td aria-label={'№'} style={{fontWeight: '600'}}><div>{itemOffset+index+1}</div></td>
                            <td aria-label={t('type_document')}><div>{item[`document_type_${i18n.language}`]}</div></td>
                            <td aria-label={t('date')}><div>{format(new Date(item.upload_date), 'dd/MM/yyyy')}</div></td>
                            <td aria-label={t('document_name')}><div>{item[`title_${i18n.language}`]}</div></td>
                            <td aria-label={t('see')}><a href={item.file ? item.file : item.url ? item.url : ''} target={'_blank'}><VisibilityIcon/>{t('see')}</a></td>
                        </tr>) : <tr/>}
                        </tbody>
                    </table>
                    {pageCount > 1 ? <div className={'pagination-news'}>
                        <ReactPaginate
                            breakLabel="..."
                            nextLabel=">"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={pageCount}
                            previousLabel="<"
                            renderOnZeroPageCount={null}
                        />
                    </div> : ''}
                </div>
            </div>
        </div>
        <Footer/>
    </div>
}
export default connect(({open_document: {open_documents}}) => ({open_documents}), {getAllOpenDocuments})(OpenDocuments)